export default "__VITE_ASSET__BCNnP99t__"